import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';

import { useMsal } from "@azure/msal-react";
import { useNavigate, useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { getRTMSData } from '../../api/auth';
import Header from '../../component/Header';
import Spinner from '../../component/Spinner';

import './RTMS.css';

const sColorMobis = "#BDBDBD";
const sColorDelivery = "#BDBDBD";
const sColorHMMA = "#BDBDBD";

function RTMS() {

    const { instance, accounts } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const navigate = useNavigate();

    const [isShow, setIsShow] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");
    const [rtmsData, setRtmsData] = useState([]);

    useEffect(() => {
        if (!activeAccount) {
            navigate("/mes");
        }
    }, [activeAccount]);

    useEffect(() => {
        setTimeout(async () => {
                try {
                    setIsShow(true);
                    const result = await getRTMSData();
                    console.log('result', result);
                    if (result.ok === true) {
                        const ts = dayjs(result.timestamp);
                        setDate(ts.format('MMM D, YYYY (ddd)'));
                        setTime(ts.format('h:mm A'));
                        setRtmsData(result.data);
                    } else {
                        alert("API CALL FAIL");
                    }
                    setTimeout(() => {
                        setRefresh((prev) => !prev);
                    }, 1000 * 15);
                } catch (error) {
                    console.log('error', error);
                    alert(error.message);
                } finally {
                    setIsShow(false);
                }
        }, 100);

    }, [refresh]);

    function onClickClose() {
        window.close();
    }

    return (
        <>
            <Spinner isShow={isShow} />
            <div className={`${isMobile ? "" : "hidden"} fixed bottom-10 right-5`}>
                <button className="border border-black rounded-sm px-10 py-5 m-1 text-4xl bg-white hover:bg-gray-400" onClick={onClickClose}>
                    CLOSE
                </button>
            </div>
            <table className="title">
                <tr>
                    <th scope="cols" style={{ textAlign: "left" }}>&nbsp;&nbsp;&nbsp;MODULE DELIVERY INFO</th>
                    <th>

                    </th>
                    <th width="250px" scope="cols" style={{ textAlign: "right", fontSize: "18pt" }}>
                        {date}&nbsp;&nbsp;&nbsp;<br />{time}&nbsp;&nbsp;&nbsp;</th>
                </tr>
            </table>
            <table className="type09">
                <thead>
                    <tr>
                        <th width="12%" scope="cols" rowspan="2">Seq.</th>
                        <th width="11%" scope="cols" rowspan="2">Dlv.Tm</th>
                        <td width="22%" scope="cols" colspan="2" style={{ borderLeft: "1px solid #ccc" }}>M<font color="red">O</font>BIS</td>
                        <td width="33%" scope="cols" colspan="3" style={{ borderLeft: "1px solid #ccc" }}>Delivery</td>
                        <td width="22%" scope="cols" colspan="2" style={{ borderLeft: "1px solid #ccc" }}>HMMA</td>
                    </tr>
                    <tr>
                        <th width="11%" scope="cols" style={{ borderLeft: "1px solid #ccc" }}>Dock</th>
                        <th width="11%" scope="cols">Gate</th>
                        <th width="11%" style={{ borderLeft: "1px solid #ccc" }} />
                        <th width="11%" />
                        <th width="11%" />
                        <th width="11%" scope="cols" style={{ borderLeft: "1px solid #ccc" }}>Gate</th>
                        <th width="11%" scope="cols">Dock</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        rtmsData?.output?.RTMS?.filter(v => v.PartName === "CPM")?.length > 0 &&
                        rtmsData?.output?.inv?.filter(v => v.LINE === "CPM").map((v, i) => {
                            const CPMMobisCnt = parseInt(v.CONV)
                            const CPMTrailerCnt = parseInt(v.TRAILERCNT)
                            const CPMHMMACnt = parseInt(v.HMMACNT)
                            return (
                                <tr>
                                    <th scope="row">Cockpit</th>
                                    <th scope="row">Inventory</th>
                                    <th scope="row" colspan="2">{CPMMobisCnt}</th>
                                    <th scope="row" colspan="3">{CPMTrailerCnt}</th>
                                    <th scope="row" colspan="2">{CPMHMMACnt}</th>
                                </tr>
                            )
                        })
                    }
                    {
                        rtmsData?.output?.RTMS?.filter(v => v.PartName === "CPM").map((v, i) => {
                            let sTruckMD = "";
                            let sTruckMG1 = "";
                            let sTruckMG2 = "";
                            let sTruckMG3 = "";
                            let sTruckMG4 = "";
                            let sTruckHG = "";
                            let sTruckHD = "";
                            let sTab = "<center><table class='truck'><tr><td><font color=white size=7pt>";
                            let sTabG = "<center><table class='truck'><tr><td><font color=white size=7pt>";
                            let sTabY = "<center><table class='truckyellow'><tr><td><font color=black size=7pt>";
                            let sTabR = "<center><table class='truckred'><tr><td><font color=white size=7pt>";
                            let sTabE = "</td></tr></table>";
                            let sMDAlarm = "";

                            let time = "";
                            let timeColor = "white";
                            if (parseInt(v.diff4) > 0) {
                                // HMMA Dock
                                time = v.diff4 + 'min';
                                sTruckHD = sTab + v.Trailer + sTabE
                            } else if (parseInt(v.diff3) > 0) {
                                // HMMA Gate
                                if (parseInt(v.diff3) > 35) {
                                    // Overdue > 35 min
                                    timeColor = "red";
                                    sTab = sTabR;
                                }
                                time = v.diff3 + 'min';
                                sTruckHG = sTab + v.Trailer + sTabE
                            } else if (parseInt(v.diff2) > 0) {
                                // MOBIS Gate
                                if (parseInt(v.diff2) > 30) {
                                    // Overdue > 30 min
                                    timeColor = "red";
                                    sTab = sTabR;
                                }
                                time = v.diff2 + 'min';

                                if (parseInt(v.diff2) < 5) {
                                    sTruckMG1 = sTab + v.Trailer + sTabE;
                                } else if (parseInt(v.diff2) < 10) {
                                    sTruckMG2 = sTab + v.Trailer + sTabE;
                                } else if (parseInt(v.diff2) < 15) {
                                    sTruckMG3 = sTab + v.Trailer + sTabE;
                                } else {
                                    sTruckMG4 = sTab + v.Trailer + sTabE;
                                }
                            } else if (parseInt(v.diff1) > 0) {
                                // MOBIS Dock
                                if (parseInt(v.diff1) > 45) {
                                    timeColor = "red";
                                    sTab = sTabR;
                                    sMDAlarm = "Truck Delay:" + v.diff1 + 'min';
                                } else if (parseInt(v.diff1) > 30) {
                                    timeColor = "yellow";
                                    sTab = sTabY;
                                }
                                time = v.diff1 + 'min';

                                sTruckMD = sTab + v.Trailer + sTabE
                            } else {
                                time = "Loading";
                            }

                            return (

                                <tr>
                                    <td scope="row" style={{ backgroundColor: "#157fcc", color: "white" }}>{v.StartSeq}~{v.EndSeq}</td>
                                    <td scope="row" style={{ backgroundColor: "#157fcc", color: timeColor }}>{time}</td>
                                    <td style={{ borderLeft: "1px solid #ccc", background: sColorMobis }} dangerouslySetInnerHTML={{ __html: sTruckMD }}></td>
                                    <td style={{ background: sColorMobis }} dangerouslySetInnerHTML={{ __html: sTruckMG1 }}></td>
                                    {sMDAlarm !== "" ? (
                                        <td style={{ borderLeft: "1px solid #ccc", background: "red" }} colspan="3">
                                            <font color='white'>{sMDAlarm}</font>
                                        </td>
                                    ) : (
                                        <>
                                            <td style={{ borderLeft: "1px solid #ccc", background: sColorDelivery }} dangerouslySetInnerHTML={{ __html: sTruckMG2 }}></td>
                                            <td style={{ background: sColorDelivery }} dangerouslySetInnerHTML={{ __html: sTruckMG3 }}></td>
                                            <td style={{ background: sColorDelivery }} dangerouslySetInnerHTML={{ __html: sTruckMG4 }}></td>
                                        </>
                                    )}
                                    <td style={{ borderLeft: "1px solid #ccc", background: sColorHMMA }} dangerouslySetInnerHTML={{ __html: sTruckHG }}></td>
                                    <td style={{ background: sColorHMMA }} dangerouslySetInnerHTML={{ __html: sTruckHD }}></td>
                                    <td style={{ background: sColorHMMA }}></td>
                                </tr>
                            )
                        })
                    }
                    {
                        rtmsData?.output?.RTMS?.filter(v => v.PartName === "FCM")?.length > 0 &&
                        rtmsData?.output?.inv?.filter(v => v.LINE === "FCM").map((v, i) => {
                            const FCMMobisCnt = parseInt(v.CONV)
                            const FCMTrailerCnt = parseInt(v.TRAILERCNT)
                            const FCMHMMACnt = parseInt(v.HMMACNT)
                            return (
                                <tr>
                                    <th scope="row">Front Chassis</th>
                                    <th scope="row">Inventory</th>
                                    <th scope="row" colspan="2">{FCMMobisCnt}</th>
                                    <th scope="row" colspan="3">{FCMTrailerCnt}</th>
                                    <th scope="row" colspan="2">{FCMHMMACnt}</th>
                                </tr>
                            )
                        })
                    }
                    {
                        rtmsData?.output?.RTMS?.filter(v => v.PartName === "FCM").map((v, i) => {

                            let sTruckMD = "";
                            let sTruckMG1 = "";
                            let sTruckMG2 = "";
                            let sTruckMG3 = "";
                            let sTruckMG4 = "";
                            let sTruckHG = "";
                            let sTruckHD = "";
                            let sTab = "<center><table class='truck'><tr><td><font color=white size=7pt>";
                            let sTabG = "<center><table class='truck'><tr><td><font color=white size=7pt>";
                            let sTabY = "<center><table class='truckyellow'><tr><td><font color=black size=7pt>";
                            let sTabR = "<center><table class='truckred'><tr><td><font color=white size=7pt>";
                            let sTabE = "</td></tr></table>";
                            let sMDAlarm = "";

                            let time = "";
                            let timeColor = "white";
                            if (parseInt(v.diff4) > 0) {
                                // HMMA Dock
                                time = v.diff4 + 'min';
                                sTruckHD = sTab + v.Trailer + sTabE
                            } else if (parseInt(v.diff3) > 0) {
                                // HMMA Gate
                                if (parseInt(v.diff3) > 35) {
                                    // Overdue > 35 min
                                    timeColor = "red";
                                    sTab = sTabR;
                                }
                                time = v.diff3 + 'min';
                                sTruckHG = sTab + v.Trailer + sTabE
                            } else if (parseInt(v.diff2) > 0) {
                                // MOBIS Gate
                                if (parseInt(v.diff2) > 30) {
                                    // Overdue > 30 min
                                    timeColor = "red";
                                    sTab = sTabR;
                                }
                                time = v.diff2 + 'min';

                                if (parseInt(v.diff2) < 5) {
                                    sTruckMG1 = sTab + v.Trailer + sTabE;
                                } else if (parseInt(v.diff2) < 10) {
                                    sTruckMG2 = sTab + v.Trailer + sTabE;
                                } else if (parseInt(v.diff2) < 15) {
                                    sTruckMG3 = sTab + v.Trailer + sTabE;
                                } else {
                                    sTruckMG4 = sTab + v.Trailer + sTabE;
                                }
                            } else if (parseInt(v.diff1) > 0) {
                                // MOBIS Dock
                                if (parseInt(v.diff1) > 45) {
                                    timeColor = "red";
                                    sTab = sTabR;
                                    sMDAlarm = "Truck Delay:" + v.diff1 + 'min';
                                } else if (parseInt(v.diff1) > 30) {
                                    timeColor = "yellow";
                                    sTab = sTabY;
                                }
                                time = v.diff1 + 'min';

                                sTruckMD = sTab + v.Trailer + sTabE
                            } else {
                                time = "Loading";
                            }

                            return (

                                <tr>
                                    <td scope="row" style={{ backgroundColor: "#157fcc", color: "white" }}>{v.StartSeq}~{v.EndSeq}</td>
                                    <td scope="row" style={{ backgroundColor: "#157fcc", color: timeColor }}>{time}</td>
                                    <td style={{ borderLeft: "1px solid #ccc", background: sColorMobis }} dangerouslySetInnerHTML={{ __html: sTruckMD }}></td>
                                    <td style={{ background: sColorMobis }} dangerouslySetInnerHTML={{ __html: sTruckMG1 }}></td>
                                    {sMDAlarm !== "" ? (
                                        <td style={{ borderLeft: "1px solid #ccc", background: "red" }} colspan="3">
                                            <font color='white'>{sMDAlarm}</font>
                                        </td>
                                    ) : (
                                        <>
                                            <td style={{ borderLeft: "1px solid #ccc", background: sColorDelivery }} dangerouslySetInnerHTML={{ __html: sTruckMG2 }}></td>
                                            <td style={{ background: sColorDelivery }} dangerouslySetInnerHTML={{ __html: sTruckMG3 }}></td>
                                            <td style={{ background: sColorDelivery }} dangerouslySetInnerHTML={{ __html: sTruckMG4 }}></td>
                                        </>
                                    )}
                                    <td style={{ borderLeft: "1px solid #ccc", background: sColorHMMA }} dangerouslySetInnerHTML={{ __html: sTruckHG }}></td>
                                    <td style={{ background: sColorHMMA }} dangerouslySetInnerHTML={{ __html: sTruckHD }}></td>
                                    <td style={{ background: sColorHMMA }}></td>
                                </tr>
                            )
                        })
                    }
                    {
                        rtmsData?.output?.RTMS?.filter(v => v.PartName === "RCM")?.length > 0 &&
                        rtmsData?.output?.inv?.filter(v => v.LINE === "RCM").map((v, i) => {
                            const RCMMobisCnt = parseInt(v.CONV)
                            const RCMTrailerCnt = parseInt(v.TRAILERCNT)
                            const RCMHMMACnt = parseInt(v.HMMACNT)
                            return (
                                <tr>
                                    <th scope="row">Rear Chassis</th>
                                    <th scope="row">Inventory</th>
                                    <th scope="row" colspan="2">{RCMMobisCnt}</th>
                                    <th scope="row" colspan="3">{RCMTrailerCnt}</th>
                                    <th scope="row" colspan="2">{RCMHMMACnt}</th>
                                </tr>
                            )
                        })
                    }
                    {
                        rtmsData?.output?.RTMS?.filter(v => v.PartName === "RCM").map((v, i) => {

                            let sTruckMD = "";
                            let sTruckMG1 = "";
                            let sTruckMG2 = "";
                            let sTruckMG3 = "";
                            let sTruckMG4 = "";
                            let sTruckHG = "";
                            let sTruckHD = "";
                            let sTab = "<center><table class='truck'><tr><td><font color=white size=7pt>";
                            let sTabG = "<center><table class='truck'><tr><td><font color=white size=7pt>";
                            let sTabY = "<center><table class='truckyellow'><tr><td><font color=black size=7pt>";
                            let sTabR = "<center><table class='truckred'><tr><td><font color=white size=7pt>";
                            let sTabE = "</td></tr></table>";
                            let sMDAlarm = "";

                            let time = "";
                            let timeColor = "white";
                            if (parseInt(v.diff4) > 0) {
                                // HMMA Dock
                                time = v.diff4 + 'min';
                                sTruckHD = sTab + v.Trailer + sTabE
                            } else if (parseInt(v.diff3) > 0) {
                                // HMMA Gate
                                if (parseInt(v.diff3) > 35) {
                                    // Overdue > 35 min
                                    timeColor = "red";
                                    sTab = sTabR;
                                }
                                time = v.diff3 + 'min';
                                sTruckHG = sTab + v.Trailer + sTabE
                            } else if (parseInt(v.diff2) > 0) {
                                // MOBIS Gate
                                if (parseInt(v.diff2) > 30) {
                                    // Overdue > 30 min
                                    timeColor = "red";
                                    sTab = sTabR;
                                }
                                time = v.diff2 + 'min';

                                if (parseInt(v.diff2) < 5) {
                                    sTruckMG1 = sTab + v.Trailer + sTabE;
                                } else if (parseInt(v.diff2) < 10) {
                                    sTruckMG2 = sTab + v.Trailer + sTabE;
                                } else if (parseInt(v.diff2) < 15) {
                                    sTruckMG3 = sTab + v.Trailer + sTabE;
                                } else {
                                    sTruckMG4 = sTab + v.Trailer + sTabE;
                                }
                            } else if (parseInt(v.diff1) > 0) {
                                // MOBIS Dock
                                if (parseInt(v.diff1) > 45) {
                                    timeColor = "red";
                                    sTab = sTabR;
                                    sMDAlarm = "Truck Delay:" + v.diff1 + 'min';
                                } else if (parseInt(v.diff1) > 30) {
                                    timeColor = "yellow";
                                    sTab = sTabY;
                                }
                                time = v.diff1 + 'min';

                                sTruckMD = sTab + v.Trailer + sTabE
                            } else {
                                time = "Loading";
                            }

                            return (

                                <tr>
                                    <td scope="row" style={{ backgroundColor: "#157fcc", color: "white" }}>{v.StartSeq}~{v.EndSeq}</td>
                                    <td scope="row" style={{ backgroundColor: "#157fcc", color: timeColor }}>{time}</td>
                                    <td style={{ borderLeft: "1px solid #ccc", background: sColorMobis }} dangerouslySetInnerHTML={{ __html: sTruckMD }}></td>
                                    <td style={{ background: sColorMobis }} dangerouslySetInnerHTML={{ __html: sTruckMG1 }}></td>
                                    {sMDAlarm !== "" ? (
                                        <td style={{ borderLeft: "1px solid #ccc", background: "red" }} colspan="3">
                                            <font color='white'>{sMDAlarm}</font>
                                        </td>
                                    ) : (
                                        <>
                                            <td style={{ borderLeft: "1px solid #ccc", background: sColorDelivery }} dangerouslySetInnerHTML={{ __html: sTruckMG2 }}></td>
                                            <td style={{ background: sColorDelivery }} dangerouslySetInnerHTML={{ __html: sTruckMG3 }}></td>
                                            <td style={{ background: sColorDelivery }} dangerouslySetInnerHTML={{ __html: sTruckMG4 }}></td>
                                        </>
                                    )}
                                    <td style={{ borderLeft: "1px solid #ccc", background: sColorHMMA }} dangerouslySetInnerHTML={{ __html: sTruckHG }}></td>
                                    <td style={{ background: sColorHMMA }} dangerouslySetInnerHTML={{ __html: sTruckHD }}></td>
                                    <td style={{ background: sColorHMMA }}></td>
                                </tr>
                            )
                        })
                    }
                    {
                        rtmsData?.bumper?.output?.RTMS?.filter(v => v.PartName === "FBP")?.length > 0 &&
                        rtmsData?.bumper?.output?.inv?.filter(v => v.LINE === "BMPF").map((v, i) => {
                            const FBPMobisCnt = parseInt(v.SHIPSCAN_CNT)
                            const FBPTrailerCnt = parseInt(v.INTRANSIT_CNT)
                            const FBPHMMACnt = parseInt(v.H_INV)
                            return (
                                <tr>
                                    <th scope="row">Front Bumper</th>
                                    <th scope="row">Inventory</th>
                                    <th scope="row" colspan="2">{FBPMobisCnt}</th>
                                    <th scope="row" colspan="3">{FBPTrailerCnt}</th>
                                    <th scope="row" colspan="2">{FBPHMMACnt}</th>
                                </tr>
                            )
                        })
                    }
                    {
                        rtmsData?.bumper?.output?.RTMS?.filter(v => v.PartName === "FBP").map((v, i) => {

                            let sTruckMD = "";
                            let sTruckMG1 = "";
                            let sTruckMG2 = "";
                            let sTruckMG3 = "";
                            let sTruckMG4 = "";
                            let sTruckHG = "";
                            let sTruckHD = "";
                            let sTab = "<center><table class='truck'><tr><td><font color=white size=7pt>";
                            let sTabG = "<center><table class='truck'><tr><td><font color=white size=7pt>";
                            let sTabY = "<center><table class='truckyellow'><tr><td><font color=black size=7pt>";
                            let sTabR = "<center><table class='truckred'><tr><td><font color=white size=7pt>";
                            let sTabE = "</td></tr></table>";
                            let sMDAlarm = "";

                            let time = "";
                            let timeColor = "white";
                            if (parseInt(v.diff4) > 0) {
                                // HMMA Dock
                                time = v.diff4 + 'min';
                                sTruckHD = sTab + v.Trailer + sTabE
                            } else if (parseInt(v.diff3) > 0) {
                                // HMMA Gate
                                if (parseInt(v.diff3) > 35) {
                                    // Overdue > 35 min
                                    timeColor = "red";
                                    sTab = sTabR;
                                }
                                time = v.diff3 + 'min';
                                sTruckHG = sTab + v.Trailer + sTabE
                            } else if (parseInt(v.diff2) > 0) {
                                // MOBIS Gate
                                if (parseInt(v.diff2) > 30) {
                                    // Overdue > 30 min
                                    timeColor = "red";
                                    sTab = sTabR;
                                }
                                time = v.diff2 + 'min';

                                if (parseInt(v.diff2) < 5) {
                                    sTruckMG1 = sTab + v.Trailer + sTabE;
                                } else if (parseInt(v.diff2) < 10) {
                                    sTruckMG2 = sTab + v.Trailer + sTabE;
                                } else if (parseInt(v.diff2) < 15) {
                                    sTruckMG3 = sTab + v.Trailer + sTabE;
                                } else {
                                    sTruckMG4 = sTab + v.Trailer + sTabE;
                                }
                            } else if (parseInt(v.diff1) > 0) {
                                // MOBIS Dock
                                if (parseInt(v.diff1) > 45) {
                                    timeColor = "red";
                                    sTab = sTabR;
                                    sMDAlarm = "Truck Delay:" + v.diff1 + 'min';
                                } else if (parseInt(v.diff1) > 30) {
                                    timeColor = "yellow";
                                    sTab = sTabY;
                                }
                                time = v.diff1 + 'min';

                                sTruckMD = sTab + v.Trailer + sTabE
                            } else {
                                time = "Loading";
                            }

                            return (

                                <tr>
                                    <td scope="row" style={{ backgroundColor: "#157fcc", color: "white" }}>{v.StartSeq}~{v.EndSeq}</td>
                                    <td scope="row" style={{ backgroundColor: "#157fcc", color: timeColor }}>{time}</td>
                                    <td style={{ borderLeft: "1px solid #ccc", background: sColorMobis }} dangerouslySetInnerHTML={{ __html: sTruckMD }}></td>
                                    <td style={{ background: sColorMobis }} dangerouslySetInnerHTML={{ __html: sTruckMG1 }}></td>
                                    {sMDAlarm !== "" ? (
                                        <td style={{ borderLeft: "1px solid #ccc", background: "red" }} colspan="3">
                                            <font color='white'>{sMDAlarm}</font>
                                        </td>
                                    ) : (
                                        <>
                                            <td style={{ borderLeft: "1px solid #ccc", background: sColorDelivery }} dangerouslySetInnerHTML={{ __html: sTruckMG2 }}></td>
                                            <td style={{ background: sColorDelivery }} dangerouslySetInnerHTML={{ __html: sTruckMG3 }}></td>
                                            <td style={{ background: sColorDelivery }} dangerouslySetInnerHTML={{ __html: sTruckMG4 }}></td>
                                        </>
                                    )}
                                    <td style={{ borderLeft: "1px solid #ccc", background: sColorHMMA }} dangerouslySetInnerHTML={{ __html: sTruckHG }}></td>
                                    <td style={{ background: sColorHMMA }} dangerouslySetInnerHTML={{ __html: sTruckHD }}></td>
                                    <td style={{ background: sColorHMMA }}></td>
                                </tr>
                            )
                        })
                    }
                    {
                        rtmsData?.bumper?.output?.RTMS?.filter(v => v.PartName === "RBP")?.length > 0 &&
                        rtmsData?.bumper?.output?.inv?.filter(v => v.LINE === "BMPR").map((v, i) => {
                            const RBPMobisCnt = parseInt(v.SHIPSCAN_CNT)
                            const RBPTrailerCnt = parseInt(v.INTRANSIT_CNT)
                            const RBPHMMACnt = parseInt(v.H_INV)
                            return (
                                <tr>
                                    <th scope="row">Rear Bumper</th>
                                    <th scope="row">Inventory</th>
                                    <th scope="row" colspan="2">{RBPMobisCnt}</th>
                                    <th scope="row" colspan="3">{RBPTrailerCnt}</th>
                                    <th scope="row" colspan="2">{RBPHMMACnt}</th>
                                </tr>
                            )
                        })
                    }
                    {
                        rtmsData?.bumper?.output?.RTMS?.filter(v => v.PartName === "RBP").map((v, i) => {

                            let sTruckMD = "";
                            let sTruckMG1 = "";
                            let sTruckMG2 = "";
                            let sTruckMG3 = "";
                            let sTruckMG4 = "";
                            let sTruckHG = "";
                            let sTruckHD = "";
                            let sTab = "<center><table class='truck'><tr><td><font color=white size=7pt>";
                            let sTabG = "<center><table class='truck'><tr><td><font color=white size=7pt>";
                            let sTabY = "<center><table class='truckyellow'><tr><td><font color=black size=7pt>";
                            let sTabR = "<center><table class='truckred'><tr><td><font color=white size=7pt>";
                            let sTabE = "</td></tr></table>";
                            let sMDAlarm = "";

                            let time = "";
                            let timeColor = "white";
                            if (parseInt(v.diff4) > 0) {
                                // HMMA Dock
                                time = v.diff4 + 'min';
                                sTruckHD = sTab + v.Trailer + sTabE
                            } else if (parseInt(v.diff3) > 0) {
                                // HMMA Gate
                                if (parseInt(v.diff3) > 35) {
                                    // Overdue > 35 min
                                    timeColor = "red";
                                    sTab = sTabR;
                                }
                                time = v.diff3 + 'min';
                                sTruckHG = sTab + v.Trailer + sTabE
                            } else if (parseInt(v.diff2) > 0) {
                                // MOBIS Gate
                                if (parseInt(v.diff2) > 30) {
                                    // Overdue > 30 min
                                    timeColor = "red";
                                    sTab = sTabR;
                                }
                                time = v.diff2 + 'min';

                                if (parseInt(v.diff2) < 5) {
                                    sTruckMG1 = sTab + v.Trailer + sTabE;
                                } else if (parseInt(v.diff2) < 10) {
                                    sTruckMG2 = sTab + v.Trailer + sTabE;
                                } else if (parseInt(v.diff2) < 15) {
                                    sTruckMG3 = sTab + v.Trailer + sTabE;
                                } else {
                                    sTruckMG4 = sTab + v.Trailer + sTabE;
                                }
                            } else if (parseInt(v.diff1) > 0) {
                                // MOBIS Dock
                                if (parseInt(v.diff1) > 45) {
                                    timeColor = "red";
                                    sTab = sTabR;
                                    sMDAlarm = "Truck Delay:" + v.diff1 + 'min';
                                } else if (parseInt(v.diff1) > 30) {
                                    timeColor = "yellow";
                                    sTab = sTabY;
                                }
                                time = v.diff1 + 'min';

                                sTruckMD = sTab + v.Trailer + sTabE
                            } else {
                                time = "Loading";
                            }

                            return (

                                <tr>
                                    <td scope="row" style={{ backgroundColor: "#157fcc", color: "white" }}>{v.StartSeq}~{v.EndSeq}</td>
                                    <td scope="row" style={{ backgroundColor: "#157fcc", color: timeColor }}>{time}</td>
                                    <td style={{ borderLeft: "1px solid #ccc", background: sColorMobis }} dangerouslySetInnerHTML={{ __html: sTruckMD }}></td>
                                    <td style={{ background: sColorMobis }} dangerouslySetInnerHTML={{ __html: sTruckMG1 }}></td>
                                    {sMDAlarm !== "" ? (
                                        <td style={{ borderLeft: "1px solid #ccc", background: "red" }} colspan="3">
                                            <font color='white'>{sMDAlarm}</font>
                                        </td>
                                    ) : (
                                        <>
                                            <td style={{ borderLeft: "1px solid #ccc", background: sColorDelivery }} dangerouslySetInnerHTML={{ __html: sTruckMG2 }}></td>
                                            <td style={{ background: sColorDelivery }} dangerouslySetInnerHTML={{ __html: sTruckMG3 }}></td>
                                            <td style={{ background: sColorDelivery }} dangerouslySetInnerHTML={{ __html: sTruckMG4 }}></td>
                                        </>
                                    )}
                                    <td style={{ borderLeft: "1px solid #ccc", background: sColorHMMA }} dangerouslySetInnerHTML={{ __html: sTruckHG }}></td>
                                    <td style={{ background: sColorHMMA }} dangerouslySetInnerHTML={{ __html: sTruckHD }}></td>
                                    <td style={{ background: sColorHMMA }}></td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </>
    )
}

export default RTMS;
